import { React } from 'react'
import styled from 'styled-components'
import { useSelector, shallowEqual } from 'react-redux'

import Divider from '@material-ui/core/Divider'
import List from '@material-ui/core/List'
import ListSubheader from '@material-ui/core/ListSubheader'
import Typography from '@material-ui/core/Typography'
import Skeleton from '@material-ui/lab/Skeleton'

import AnalyzedTopic from './AnalyzedTopicItem'

const StyledAnalyzedTopicList = styled(List)`
  max-width: 480px;
  height: fit-content;
  border-radius: 3px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  &.MuiList-root {
    margin: 40px 0; /* margin-collapse here lol */
  }
  &.MuiList-padding {
    padding: 10px;
  }
`

const AnalyzedTopicList = () => {
  const { recentAnalyses } = useSelector(({ recentRecords }) => {
    return {
      recentAnalyses: recentRecords.recentAnalyses
    }
  }, shallowEqual)

  return (
    <StyledAnalyzedTopicList>
      <ListSubheader component="div">
        <Typography variant="h6" component="div">
          Analyzed Topic
        </Typography>
      </ListSubheader>
      <Divider />
      {recentAnalyses.length ? (
        recentAnalyses.map((analysis) => {
          return <AnalyzedTopic analysis={analysis} key={analysis.lastRunDatetime} />
        })
      ) : (
        <>
          <Skeleton height={48} />
          <Skeleton height={48} />
          <Skeleton height={48} />
          <Skeleton height={48} />
          <Skeleton height={48} />
        </>
      )}
    </StyledAnalyzedTopicList>
  )
}

export default AnalyzedTopicList
